import React from 'react';
import { Backdrop, CircularProgress, Stack } from '@mui/material';
import useDebugInformation from '../../../hooks/useDebugInformation';
import { api, ui } from '../../../interfaces/interfaces';
import SnackbarMini from '../../Shared/SnackbarMini';
import { SnackbarProvider } from 'notistack';
import { useBeforeunload } from 'react-beforeunload';
import { subscribe, unsubscribe } from './helpers';
import CallMeBacks from './CallMeBacks';
import Content from './Content';
import NewBookingDialog from './NewBookingDialog';
import AuthorizationDialog from './CallMeBacks/CallMeBackDialog/AuthorizationDialog';
import AnonymousContent from './AnonymousContent';
import { useAppSelector } from "@store/hooks";
import Footer from '../BookingForm/MainForm/Footer';
import { AuthContext } from '../../../utilities/authProvider';

const name = "Home"

const onUnload = async (e: Event) => {
    e.preventDefault();
    if (ui.CallMeBacksModalData.leadId) {
        await api.fetchGetCallMeBackUnlock({
            id: ui.CallMeBacksModalData.leadId,
            objectTypeId: 3
        })
        ui.CallMeBacksModalData = {};
    }
}

type Props = {
    parent: string
}

const Home: React.FC<Props> = ({ parent }) => {
    const homeLoading = useAppSelector(({ state }) => state.HomeLoading)
    const authDialog = useAppSelector(({ ui }) => ui.CallMeBackAuthDialogModal);
    const { isAuthenticated } = React.useContext(AuthContext);

    const [value, setValue] = React.useState<string>("");
    useBeforeunload(onUnload);

    React.useEffect(() => {
        subscribe();

        return () => {
            unsubscribe();
        }
    }, []);

    const debugName = `${parent}▷[${name}]`

    useDebugInformation("Home", {})
    return (
        <Stack spacing={1} sx={{ m: -1, mt: -2 }}>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                style={{ zIndex: 1000 }}
                open={homeLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <input onChange={(event) => setValue(event.target.value)} value={value} hidden={true} />
            <SnackbarProvider maxSnack={3}>
                <SnackbarMini parent={debugName} />
                {isAuthenticated ? <><Content /> <CallMeBacks parent={debugName} /></> : <AnonymousContent />}
            </SnackbarProvider >
            <Footer />
            <NewBookingDialog />
            {authDialog && <AuthorizationDialog />}
        </Stack >
    );
}

Home.displayName = name;

export default React.memo(Home)